var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-history" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-icon" }),
      _c("div", { staticClass: "header-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.uniqueId,
              expression: "uniqueId"
            }
          ],
          attrs: { type: "number", placeholder: "请输入设备编号" },
          domProps: { value: _vm.uniqueId },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.uniqueId = $event.target.value
              },
              _vm.inputChange
            ]
          }
        })
      ]),
      _c(
        "div",
        { staticClass: "header-btn", on: { click: _vm.onclickSearchBtn } },
        [_vm._v("搜索")]
      ),
      _c(
        "div",
        { staticClass: "header-scan", on: { click: _vm.onclickScanBtn } },
        [_c("img", { attrs: { src: _vm.ossHost + "img/scan.png" } })]
      )
    ]),
    _vm.list.length
      ? _c(
          "div",
          { staticClass: "list" },
          [
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "list-item",
                  on: {
                    click: function($event) {
                      return _vm.onclickListItem(item)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
                  }),
                  _c("div", { staticClass: "item-num" }, [
                    _vm._v(_vm._s(item.uniqueId))
                  ]),
                  _c("div", { staticClass: "item-content" }, [
                    _c("div", { staticClass: "item-content-name" }, [
                      _vm._v(_vm._s(item.operationName))
                    ]),
                    _c("div", { staticClass: "item-content-time" }, [
                      _vm._v(_vm._s(item.time))
                    ])
                  ])
                ]
              )
            }),
            _c("div", { staticClass: "loading-text" }, [
              _vm._v(_vm._s(_vm.isShowAll ? "已展示全部记录" : "加载中..."))
            ])
          ],
          2
        )
      : _vm._e(),
    _vm.loaded && !_vm.list.length
      ? _c("div", { staticClass: "empty-box" }, [
          _c("img", {
            attrs: { src: _vm.ossPondHost + "img/empty_controller.png" }
          }),
          _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无质检记录")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }